/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DaylistCenterSupplier
 */
export interface DaylistCenterSupplier {
    /**
     * 
     * @type {number}
     * @memberof DaylistCenterSupplier
     */
    centerId: number | null;
    /**
     * 
     * @type {string}
     * @memberof DaylistCenterSupplier
     */
    orgSupplierId: string | null;
    /**
     * 
     * @type {number}
     * @memberof DaylistCenterSupplier
     */
    dateno: number | null;
    /**
     * 
     * @type {string}
     * @memberof DaylistCenterSupplier
     */
    rectype: string | null;
    /**
     * 
     * @type {string}
     * @memberof DaylistCenterSupplier
     */
    colname: string | null;
    /**
     * 
     * @type {Date}
     * @memberof DaylistCenterSupplier
     */
    datevalue: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof DaylistCenterSupplier
     */
    orderDate: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof DaylistCenterSupplier
     */
    isOrderConfirmed: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof DaylistCenterSupplier
     */
    isOrderToday: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof DaylistCenterSupplier
     */
    isUpdatedArrivalTmp: boolean | null;
}

/**
 * Check if a given object implements the DaylistCenterSupplier interface.
 */
export function instanceOfDaylistCenterSupplier(value: object): value is DaylistCenterSupplier {
    if (!('centerId' in value) || value['centerId'] === undefined) return false;
    if (!('orgSupplierId' in value) || value['orgSupplierId'] === undefined) return false;
    if (!('dateno' in value) || value['dateno'] === undefined) return false;
    if (!('rectype' in value) || value['rectype'] === undefined) return false;
    if (!('colname' in value) || value['colname'] === undefined) return false;
    if (!('datevalue' in value) || value['datevalue'] === undefined) return false;
    if (!('orderDate' in value) || value['orderDate'] === undefined) return false;
    if (!('isOrderConfirmed' in value) || value['isOrderConfirmed'] === undefined) return false;
    if (!('isOrderToday' in value) || value['isOrderToday'] === undefined) return false;
    if (!('isUpdatedArrivalTmp' in value) || value['isUpdatedArrivalTmp'] === undefined) return false;
    return true;
}

export function DaylistCenterSupplierFromJSON(json: any): DaylistCenterSupplier {
    return DaylistCenterSupplierFromJSONTyped(json, false);
}

export function DaylistCenterSupplierFromJSONTyped(json: any, ignoreDiscriminator: boolean): DaylistCenterSupplier {
    if (json == null) {
        return json;
    }
    return {
        
        'centerId': json['center_id'],
        'orgSupplierId': json['org_supplier_id'],
        'dateno': json['dateno'],
        'rectype': json['rectype'],
        'colname': json['colname'],
        'datevalue': (json['datevalue'] == null ? null : new Date(json['datevalue'])),
        'orderDate': (json['order_date'] == null ? null : new Date(json['order_date'])),
        'isOrderConfirmed': json['is_order_confirmed'],
        'isOrderToday': json['is_order_today'],
        'isUpdatedArrivalTmp': json['is_updated_arrival_tmp'],
    };
}

export function DaylistCenterSupplierToJSON(json: any): DaylistCenterSupplier {
    return DaylistCenterSupplierToJSONTyped(json, false);
}

export function DaylistCenterSupplierToJSONTyped(value?: DaylistCenterSupplier | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'center_id': value['centerId'],
        'org_supplier_id': value['orgSupplierId'],
        'dateno': value['dateno'],
        'rectype': value['rectype'],
        'colname': value['colname'],
        'datevalue': value['datevalue'] == null ? value['datevalue'] : value['datevalue'].toISOString(),
        'order_date': value['orderDate'] == null ? value['orderDate'] : value['orderDate'].toISOString().substring(0,10),
        'is_order_confirmed': value['isOrderConfirmed'],
        'is_order_today': value['isOrderToday'],
        'is_updated_arrival_tmp': value['isUpdatedArrivalTmp'],
    };
}

